import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {
  className?: string;
  color?: string;
}

const CopyRoundedIcon: React.FC<Props> = ({ className, color = 'currentColor' }) => {
  return (
    <SVGIcon viewBox="0 0 24 24" width="24" height="24" fill="none" className={className}>
      <rect
        width="14"
        height="14"
        x="8"
        y="8"
        rx="2"
        ry="2"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGIcon>
  );
};

export default CopyRoundedIcon;
